<script lang="ts" setup>
import { refThrottled } from '@vueuse/core';
import { MdPreview } from 'md-editor-v3';
import 'md-editor-v3/lib/preview.css';
import { appLinkOfClick, chatAnswerEditorId, chatAnswerSanitizer } from '~/utils/chat-answer';
import { supportPreviewLanguage } from '~/utils/support-markdown';

const props = defineProps<{
  turnId: string;
  text: string;
}>();

const { locale } = useI18n();

const sanitize = chatAnswerSanitizer(window.location.origin);
const editorId = computed(() => chatAnswerEditorId(props.turnId));
// Each render parses and sanitizes the whole text. A stream gives many small deltas, so the
// preview takes the text at most a few times a second. The trailing update shows the last text.
const shownText = refThrottled(
  toRef(() => props.text),
  150,
  true,
  true,
);

// The router opens an app link, so the panel and the chat stay open.
const openAppLink = (event: MouseEvent) => {
  const path = appLinkOfClick(event, window.location.origin);
  if (path === null) return;
  event.preventDefault();
  void navigateTo(path);
};
</script>

<template>
  <MdPreview
    :id="editorId"
    :model-value="shownText"
    :sanitize="sanitize"
    :language="supportPreviewLanguage(locale)"
    theme="light"
    preview-theme="default"
    no-katex
    no-mermaid
    no-highlight
    :code-foldable="false"
    @click="openAppLink"
  />
</template>
